<p>
  service-add works!
</p>
